import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-gs-next-steps',
	templateUrl:'./NextStepsPage.html',
	styles: [],
	styleUrls:['./NextStepsPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		RouterModule,
		WaButtonDirective,
],
	standalone:true
})
export class NextStepsPage
{
}
